if (!customElements.get('rl-vr-gallery')) {
  customElements.define('rl-vr-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.addEventListener('click', e => {
        const thumb = e.target.closest('button[data-photo]');
        if (thumb) {
          const color = thumb.dataset.color;
          const radio = Array.from(document.querySelectorAll('.product-details input[data-option-name="Color"]')).find(x => x.value === color);
          if (radio && !radio.checked) radio.click();
          this.show(thumb);
          return;
        }
        if (e.target.closest('.vr-gallery-prev')) this.step(-1);
        if (e.target.closest('.vr-gallery-next')) this.step(1);
      }, opts);
      document.addEventListener('change', e => {
        if (e.target.matches('.product-details input[data-option-name="Color"]')) {
          const thumb = Array.from(this.querySelectorAll('button[data-primary="true"]')).find(x => x.dataset.color === e.target.value);
          if (thumb) this.show(thumb);
        }
      }, opts);
    }
    disconnectedCallback() { this.abort?.abort(); }
    show(thumb) {
      const image = this.querySelector('.vr-gallery-image');
      if (!image || !thumb) return;
      image.src = thumb.dataset.photo;
      image.alt = thumb.getAttribute('aria-label');
      this.querySelectorAll('[data-photo]').forEach(x => x.setAttribute('aria-pressed', String(x === thumb)));
      this.dataset.color = thumb.dataset.color;
    }
    step(offset) {
      const buttons = Array.from(this.querySelectorAll('button[data-photo]'));
      const current = Math.max(0, buttons.findIndex(x => x.getAttribute('aria-pressed') === 'true'));
      buttons[(current + offset + buttons.length) % buttons.length]?.click();
    }
  });
}
